import $ from 'jquery'

const initializeBlock = function ($block) {
  const accordions = $block.find('.feed-faq')
  const filterButton = $block.find('.faq-block__filter')

  filterButton.on('click', function () {
    filterButton.removeClass('faq-block__filter--active')
    $(this).addClass('faq-block__filter--active')

    const termId = $(this).attr('data-id')

    accordions.map((index, accordion) => {
      const current = $(accordion)
      if (!current.hasClass('feed-faq--mobile')) {
        const types = current.attr('data-types').split(',')

        const has = types.includes(termId)

        if (has) {
          current.slideDown()
        } else {
          current.slideUp()
        }
      }
    })
  })

  filterButton.eq(0).click()
}

$('.faq-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=nrj-faq', initializeBlock)
}
